var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C4F26",
    fillRule: "evenodd",
    d: "M4.95 7 0 11.95l1.414 1.414 4.95-4.95 4.95 4.95 1.414-1.414L7.778 7l4.95-4.95L11.314.636l-4.95 4.95-4.95-4.95L0 2.05z",
    clipRule: "evenodd"
  })));
};
export default SvgClose;